import { ScreenSize } from '../hooks/useScreenSize';

export interface ColumnWidths {
  category: number;
  card: number;
  annualFee: number;
  earnRate: number;
  centsPerPoint: number;
  centsPerDollar: number;
}

const COLUMN_WIDTHS: Record<ScreenSize, ColumnWidths> = {
  desktop: {
    category: 200,
    card: 350,
    annualFee: 100,
    earnRate: 150,
    centsPerPoint: 120,
    centsPerDollar: 150,
  },
  tablet: {
    category: 150,
    card: 280,
    annualFee: 80,
    earnRate: 120,
    centsPerPoint: 100,
    centsPerDollar: 120,
  },
  mobile: {
    category: 120,
    card: 200,
    annualFee: 60,
    earnRate: 100,
    centsPerPoint: 80,
    centsPerDollar: 100,
  },
};

export const getColumnWidths = (screenSize: ScreenSize): ColumnWidths => {
  return COLUMN_WIDTHS[screenSize];
};

export const getColumnStyle = (width: number) => ({
  flex: `0 0 ${width}px`,
});
